import { IconName, IconPrefix } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { EFonts } from 'libs/styles/styling';
import styled, { css } from 'styled-components/macro';

export interface MapV2ButtonProps {
    className?: string;
    label?: string;
    icon?: { prefix: IconPrefix; iconName: IconName };
    iconSrc?: string;
    type?: 'light' | 'dark';
    onClick: () => void;
    style?: React.CSSProperties;
}

export const MapV2Button = (props: MapV2ButtonProps): JSX.Element => {
    const type = props.type || 'light';

    function getColor() {
        if (type === 'light') {
            return '#2a2a2d';
        }
        if (type === 'dark') {
            return '#fff';
        }
    }

    function getBgColor() {
        if (type === 'light') {
            return '#fff';
        }
        if (type === 'dark') {
            return '#2A2A2D';
        }
    }

    function getHoverColor() {
        if (type === 'light') {
            return '#ededed';
        }
        if (type === 'dark') {
            return '#303034';
        }
    }

    const color = getColor();
    const bgColor = getBgColor();
    const hoverColor = getHoverColor();

    const iconOnly = (props.icon || props.iconSrc) && !props.label;

    return (
        <S_MapV2Button
            className={props.className}
            onClick={props.onClick}
            $bgColor={bgColor}
            $fixedSize={iconOnly}
            $hoverColor={hoverColor}
            style={props.style}
        >
            {props.icon && (
                <S_Icon icon={[props.icon.prefix, props.icon.iconName]} $color={color} />
            )}
            {props.iconSrc && <S_IconSrc src={props.iconSrc} />}
            {props.label && <S_Text $color={color}>{props.label}</S_Text>}
        </S_MapV2Button>
    );
};

const S_MapV2Button = styled.div<{ $bgColor: string; $fixedSize: boolean; $hoverColor: string }>`
    background: ${(props) => props.$bgColor};
    border-radius: 10px;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    gap: 12px;
    padding: 13px 20px;
    user-select: none;
    ${(props) =>
        props.$fixedSize &&
        css`
            width: 45px;
            height: 45px;
        `}
    &:hover {
        background: ${(props) => props.$hoverColor};
    }
`;

const S_Icon = styled(FontAwesomeIcon)<{ $color: string }>`
    color: ${(props) => props.$color};
    font-size: 18px;
`;
const S_IconSrc = styled.img`
    width: 15px;
    height: auto;
`;

const S_Text = styled.div<{ $color: string }>`
    color: ${(props) => props.$color};
    font-family: ${EFonts.InterSemiBold};
    font-size: 14px;
    line-height: 17px;
    margin-top: -1px;
`;
